/**
 * Product Carousel Navigation
 * Vanilla JavaScript replacement for jQuery-based carousel functionality
 */

class ProductCarousel {
  constructor() {
    this.imgWidth = 0;
    this.imageIndex = 0;
    this.interval = null;
    this.titles = [
      '.carousel-title-kite',
      '.carousel-title-wake', 
      '.carousel-title-skate',
      '.carousel-title-surf',
      '.carousel-title-canoeing',
      '.carousel-title-foil'
    ];
    
    this.init();
  }

  init() {
    const carouselColumn = document.querySelector('.carousel-column-2');
    if (!carouselColumn) return;

    const firstImage = carouselColumn.querySelector('img');
    if (firstImage) {
      this.imgWidth = firstImage.offsetWidth;
      this.setupEventListeners();
      setTimeout(() => this.startScrolling(), 1000);
    }
  }

  scrollToImage() {
    const carouselColumn = document.querySelector('.carousel-column-2');
    if (!carouselColumn) return;

    // Smooth scroll to image
    carouselColumn.scrollTo({
      left: this.imgWidth * this.imageIndex,
      behavior: 'smooth'
    });

    // Update title classes
    this.titles.forEach(titleSelector => {
      const element = document.querySelector(titleSelector);
      if (element) {
        const className = titleSelector.slice(1) + '-hover';
        element.classList.remove(className);
      }
    });

    const activeTitle = document.querySelector(this.titles[this.imageIndex]);
    if (activeTitle) {
      const className = this.titles[this.imageIndex].slice(1) + '-hover';
      activeTitle.classList.add(className);
    }

    this.imageIndex = (this.imageIndex + 1) % 6;
  }

  scrollToImageFast() {
    const carouselColumn = document.querySelector('.carousel-column-2');
    if (!carouselColumn) return;

    carouselColumn.scrollTo({
      left: this.imgWidth * this.imageIndex,
      behavior: 'smooth'
    });

    this.titles.forEach(titleSelector => {
      const element = document.querySelector(titleSelector);
      if (element) {
        const className = titleSelector.slice(1) + '-hover';
        element.classList.remove(className);
      }
    });

    const activeTitle = document.querySelector(this.titles[this.imageIndex]);
    if (activeTitle) {
      const className = this.titles[this.imageIndex].slice(1) + '-hover';
      activeTitle.classList.add(className);
    }
  }

  startScrolling() {
    this.interval = setInterval(() => this.scrollToImage(), 1500);
  }

  stopScrolling() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  setupEventListeners() {
    this.titles.forEach((titleSelector, index) => {
      const element = document.querySelector(titleSelector);
      if (element) {
        element.addEventListener('mouseenter', () => {
          this.imageIndex = index;
          this.scrollToImageFast();
          this.stopScrolling();
        });

        element.addEventListener('mouseleave', () => {
          this.startScrolling();
        });
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductCarousel());
} else {
  new ProductCarousel();
}

